import { getStore as getListViewStore, isPriorityView, type SortColumn } from 'owa-mail-list-store';
import { getMailboxInfoFromTableViewId } from 'owa-mail-mailboxinfo/lib/getMailboxInfo';
import folderIdToName from 'owa-session-store/lib/utils/folderIdToName';
import type { MailFolderTableQuery } from 'owa-mail-list-store';
import { isPrioritizeOnDemandOn } from 'owa-copilot-settings-utils';
import type FocusedViewFilter from 'owa-service/lib/contract/FocusedViewFilter';
import { isUnifiedInboxMailboxInfo } from 'owa-client-types/lib/UnifiedInboxMailboxInfo';

export function shouldShowPrioritizeButton(tableViewId: string): boolean {
    const mailboxInfo = getMailboxInfoFromTableViewId(tableViewId);
    const tableView = getListViewStore().tableViews.get(tableViewId);
    const folderTableQuery = tableView?.tableQuery as MailFolderTableQuery;
    const selectedSort = folderTableQuery?.sortBy;
    const isPriorityViewSelected = isPriorityView(folderTableQuery);

    if (isUnifiedInboxMailboxInfo(mailboxInfo)) {
        return false;
    }

    if (!selectedSort) {
        return false;
    }

    if (folderTableQuery?.focusedViewFilter === 1) {
        return false;
    }

    const isDescendingDateSort =
        selectedSort.sortColumn === 1 && selectedSort.sortDirection === 'Descending';
    if (!isDescendingDateSort && !isPriorityViewSelected) {
        return false;
    }

    const isInboxFolder = folderIdToName(tableView?.tableQuery?.folderId ?? '') === 'inbox';
    if (!isInboxFolder) {
        return false;
    }

    return isPrioritizeOnDemandOn(mailboxInfo);
}
